import { render, staticRenderFns } from "./sysuser_role_edit.vue?vue&type=template&id=4dadd95c&scoped=true"
import script from "./sysuser_role_edit.vue?vue&type=script&lang=js"
export * from "./sysuser_role_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dadd95c",
  null
  
)

export default component.exports